import * as React from 'react';
import PopupContent from './PopupContent';

function ErrorPopupContent(props) {
    return (
        <PopupContent
            problems={props.problems}
            intro=" We have identified several issues that are preventing the
                chatbot from launching."
            description="Errors prevent the project from launching."
            close={props.close}
            hideFooter={props.hideFooter}
        />
    );
}

export default ErrorPopupContent;
